import { Navigate } from "react-router-dom"
import { LoadingLogo } from "@/components/ui/LoadingLogo"
import { useAuth } from "@/hooks/useAuth"

interface ProtectedRouteProps {
   children: React.ReactNode
   allowedRoles?: ("admin" | "young")[]
}

export const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
   const { authUser, user, isLoading } = useAuth()

   if (!authUser || !user) {
      if (isLoading) {
         return <LoadingLogo />
      }
      return <Navigate to="/connexion" />
   }

   if (allowedRoles && !allowedRoles.includes(user.role)) {
      return <Navigate to="/" />
   }

   return <>{children}</>
}
